import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { collectSheets, exportTablesToExcel } from './index';
import styles from './excelButton.module.scss';
/**
 * Кнопка «Выгрузить в Excel».
 *
 * Один вид и одно поведение на весь портал: где есть таблица, там и
 * кнопка. Выгрузка читает саму отрисованную таблицу, поэтому описывать
 * колонки под каждый экран не нужно.
 */
const ExcelButton = ({ source, fileName, name, meta, disabled, compact, className }) => {
    const { t } = useTranslation();
    const label = String(t('an_export'));
    const run = () => {
        const sheets = collectSheets(source.current, name, meta);
        if (sheets.length)
            exportTablesToExcel({ fileName, sheets });
    };
    return (_jsxs("button", Object.assign({ type: "button", disabled: disabled, className: `${styles.btn} ${compact ? styles.compact : ''} ${className || ''}`, title: label, onClick: run }, { children: [_jsx("i", { className: "fa-solid fa-file-excel" }), !compact && _jsx("span", { children: label })] })));
};
export default ExcelButton;
